// import * as userTypes from '../user/actions'
// import * as enterpriseTypes from '../enterprise/actions'
// import * as accountantTypes from '../accountants/actions'
// import * as subscriptionTypes from '../subscriptions/actions'
// import {docCookies} from '../utils/docCookies'
//
import { LOCATION_CHANGE } from 'react-router-redux';
const queryString = require('query-string')


const initialState = {
    email: null,
    // route params from location.search
    wfemail: null,
    slt: null,
    redirectTo: null,
    redirect_to: null,
    signup_type: null, //for h3: (signupType == 'accountants') ? "Accountant Sign Up" : "Welcome to Everlance!",
    initialParams: {},
    hasOnboarded: false
}

export default function user(state=initialState, action) {
  switch (action.type) {

    case LOCATION_CHANGE:
      const { pathname, search, hash } = action.payload
      const {slt, wfemail} = queryString.parse(search)
      const newState = {
        ...state,
        ...queryString.parse(search),
        // email: wfemail
      }
      // only assign email if the wfemail query exists
      if (wfemail) newState.email = wfemail
      // if (slt) newState.slt = slt
      // if (redirectTo) newState.redirectTo = redirectTo

      return newState

    case "CHECK_EMAIL_SUCCESS":
      return {
        ...state,
        email: action.email
      }
    case "FINISH_ONBOARDING":
      return {
        ...state,
        hasOnboarded: true
      }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/user/reducer.js